import _ from 'lodash';

export const SET_PLACE        = 'SET_PLACE';
export const UPDATE_FAVOURITE = 'UPDATE_FAVOURITE';

export const updateFavourite = (favourite) => {
    return {
        type     : UPDATE_FAVOURITE,
        favourite: favourite
    }
};

const isFavourite = (placeId, favourites) => {
    return (-1 < favourites.indexOf(placeId));
};

/** Action to retrieve a place from the place array **/

export const setPlace = (placeId) => {
    return (dispatch, getState) => {
        let favourites = getState().user.favourites;
        let places     = getState().places.items;
        let place      = _.find(places, { slug: placeId });
        if (!place)
        {
            place = _.find(places, { id: placeId });
        }
        dispatch({
            type     : SET_PLACE,
            id       : place.id,
            place    : place,
            favourite: isFavourite(placeId, favourites)
        });
        window.scrollTo(0, 0);
    }
};



// WEBPACK FOOTER //
// ./src/actions/PlaceAction.js